import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import { useStyles } from './Style';
import clsx from 'clsx';
import { SimpleDialog, Icons } from 'components';
import BodyForm from '../BodyForm';

const Params = ({ block, update, parentIndex, remove, isChild }) => {
  const classes = useStyles();

  const [openDialog, setOpenDialog] = useState(false);
  const [titleDialog] = useState('تعریف پارامتر جدید');
  const [model, setModel] = useState(block);
  const [editSelected, setEditSelected] = useState({});
  const [action, setAction] = useState('add');

  const formDialog = (action) => {
    if (action === 'edit') {
      setAction('edit');
      const data = { ...model };
      if (data.scParameters) {
        delete data.scParameters;
      }
      setEditSelected(data);
    } else {
      setAction('add');
      setEditSelected({});
    }
    setOpenDialog(true);
  };

  const doAction = (newData, action) => {
    const actions = {
      add: addParam,
      edit: editParam,
    };
    actions[action](newData);
  };

  const addParam = (newData) => {
    const data = model?.scParameters ? [...model.scParameters, newData] : [newData];

    setModel((prev) => ({ ...prev, scParameters: [...data] }));
    update({ ...model, scParameters: [...data] });
    setOpenDialog(false);
  };

  const editParam = (data, i) => {
    setModel((prev) => ({ ...prev, ...data }));
    update({ ...model, ...data });
    setOpenDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const updateParam = (newData, i) => {
    model.scParameters[i] = newData;
    setModel(model);
    update(model);
  };

  const removeLocal = (i) => {
    const data = { ...model };
    data.scParameters.splice(i, 1);

    setModel(data);
    update(data);
  };

  useEffect(() => {
    setModel(block);
  }, [block]);

  return (
    <Box>
      <Grid container direction="row" spacing={2}>
        <Grid
          item
          xs={12}
          className={classes.block}
          container
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={7}>
            <Button onClick={() => formDialog('edit')}>
              <Typography className={classes.titleParam}>
                <span className="type">({model.scParameterType})</span> {model.scParameterName}
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button onClick={() => formDialog('add')} startIcon={<Icons icon='SubdirectoryArrowLeft' color='#303DBF' size='23' />}>
              پارامتر زیر سطح
            </Button>
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="remove" component="button" onClick={remove} size="large">
              <Icons icon='Trash' color='#303DBF' size='23' />
            </IconButton>
          </Grid>
        </Grid>

        {model?.scParameters && model.scParameters.length > 0 && (
          <Grid item xs={12}>
            <Box pl={3}>
              {model.scParameters.map((block, index) => (
                <div style={{ position: 'relative' }}>
                  <div
                    className={clsx({
                      [classes.vl]: true,
                      [classes.vlChild]: isChild,
                    })}
                  />
                  <div className={classes.hl} />
                  <Params
                    block={block}
                    key={index + parentIndex}
                    update={(newData) => updateParam(newData, index)}
                    remove={() => removeLocal(index)}
                    isChild
                  />
                </div>
              ))}
            </Box>
          </Grid>
        )}
        <SimpleDialog
          fullWidth
          maxWidth="sm"
          open={openDialog}
          title={titleDialog}
          onClose={handleCloseDialog}
        >
          <BodyForm onClick={doAction} data={editSelected} action={action} />
        </SimpleDialog>
      </Grid>
    </Box>
  );
};

export default Params;
